export const processTypes = [
  { id: 'All', description: 'Todos' },
  { id: 'BPO', description: 'SEGURADORA' },
  { id: 'LR', description: 'LOGÍSTICA REVERSA' },
  { id: 'LRC', description: 'LOGISTICA REVERSA CARE PLUS' },
  { id: 'MRC', description: 'MRC' },
  { id: 'REC', description: 'RECONDICIONAMENTO FG' },
  { id: 'RED', description: 'REPARO DE ESTOQUE NÃO DOA' },
  { id: 'REX', description: 'Reparo Externo' },
  { id: 'RFB', description: 'REFURBISH' },
];
